import React from 'react';
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Typography, FormControl, Checkbox, TextField, Chip, Autocomplete } from "@mui/material";
import { CustomText } from "./Custom";

function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item) && item !== null);
}

function extractIds(validations) {
    return validations.map(validation => {
        if (isObject(validation)) {  // Check if the item is an object
            return validation.id;   // Return the ID from the object
        }
        return validation;          // Return the ID directly if not an object
    });
}

const CustomSelectWithTags = ({ selectedValidations, validationOptions, handleValidationChange, removeValidation }) => {
    selectedValidations = extractIds(selectedValidations);
  return (
    <FormControl fullWidth sx={{ mb: 2 }}>
      <CustomText>Validation</CustomText>
      <Autocomplete
        multiple
        options={validationOptions}
        getOptionLabel={(option) => option.name}
        value={selectedValidations.map(id => validationOptions.find(option => option.id === id))}
        onChange={(event, newValue) => {
          console.log(newValue,"newValue")
          handleValidationChange({
            target: {
              value: newValue.map(option => option?.id),
            },
          });
        }}
        
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              key={option?.id}
              label={option?.name}
              {...getTagProps({ index })}
              onDelete={() => removeValidation(option?.id)}
              deleteIcon={<CloseIcon />}
              sx={{
                border: "1px solid #75748F",
                borderRadius: "20px",
                backgroundColor: "#fff",
              }}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Select validations"
          />
        )}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              sx={{ marginRight: 2 }}
              checked={selected}
            />
            {option.name}
          </li>
        )}
      />
    </FormControl>
  );
};

export default CustomSelectWithTags;
